<template>
  <div class="favourite">
    <CustomizeHeader :title="title"></CustomizeHeader>
    <v-main>
      <v-row class="main py-1">
        <v-col
          class="pa-2" 
          cols="6" 
          sm="4" 
          md="3" 
          lg="2" 
          xl="2" 
          v-for="i in 10"
        >
          <v-hover
            v-slot:default="{ hover }"
          >
            <v-card 
              class="product-item" 
              :style="hover ? 'opacity: .8' : ''"
              to="/product/1"
            >
              <v-img src="https://asia.messages.swag.live/5f245bb26da4aef29f65bfa6.256x256.jpg" aspect-ratio="1.75" />
              <div class="d-flex align-center px-2 py-3">
                <v-avatar size="35" class="mr-2">
                  <v-img src="https://api.swag.live/users/5bbee8e4c1847200385e1a31/avatar.64x64.jpg"/>
                </v-avatar>
                <v-col class="pa-0 rightInfo">
                  <div class="product-title text-ellipsis">有了情婦就是要無套做到爽！有了情婦就是要無套做到爽！有了情婦就是要無套做到爽！</div>
                  <div class="d-flex align-center">
                    <v-icon color="grey">fa-shopping-bag</v-icon>
                    <span class="grey--text ml-1 mr-3" >123</span>
                    <v-icon color="grey">fa-eye</v-icon>
                    <span class="grey--text ml-1" >51</span>
                  </div>
                </v-col>
              </div>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-main>
  </div>
</template>

<script>
import CustomizeHeader from '@/components/CustomizeHeader'
export default {
  components: { CustomizeHeader },
  data() {
    return {
      title: '我的最愛'
    }
  }
}
</script>

<style lang="scss" scoped>
.favourite {
  .product-item {
    background-color: $grey-3;
    .rightInfo {
      overflow: hidden;
    }
    .product-title {
      font-size: 14px;
    }
    .v-icon {
      font-size: 12px;
    }
    span {
      font-size: 12px;
    }
  }
}
</style>